import RawResourceIcon from "@/app/components/logos/resources/RawResourceIcon";
import { Resources } from "@/types/subject-schema";
import { Card, Text } from "@mantine/core";
import classes from "./resource-card.module.css";

interface ResourceCardProps {
  resource: Resources;
  title: string;
  badge?: string;
  description: string;
  highlight?: boolean;
}

export default function ResourceCard({
  resource,
  title,
  badge,
  description,
  highlight = false,
}: ResourceCardProps) {
  return (
    <Card className={classes.card} data-highlight={highlight ? "true" : undefined}>
      {badge && <span className={classes.badge}>{badge}</span>}
      <RawResourceIcon
        className={classes.iconBg}
        resource={resource}
        subjectNameLower={"biology"}
      />
      <Text className={classes.title}>{title}</Text>
      <Text className={classes.description}>{description}</Text>
    </Card>
  );
}
